import React, { useState } from "react";
import { Button, Table } from "antd";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useUser } from "../context/UserContext";

const CustomTable = (props) => {
  const { loggedInUser } = useUser();
  const {
    withActions = false,
    showEdit = true,
    showDelete = true,
    showView = false,
    showDownload = false,
    showImgView = false,
    rowSelection,
    loading = false,
    bordered = false,
    size = "middle",
    rowKey = "id",
    emptyText = "No data available",
    footer,
    pageKey = null,
    // showSearch = true,
  } = props.options || {};

  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  //const [search, setSearch]=useState('')
  const enhancedColumns = Array.isArray(props.columns) ? [...props.columns] : [];
  const userPages = loggedInUser?.roles?.[0]?.pages || [];
  const access = pageKey ? userPages.find(p => p.pageId === pageKey) : null;
  const canEdit = access?.edit ?? false;
  const canView = access?.view ?? false;
  const canDelete = access?.delete ?? false;
  const hasAnyAction = (canView && showView) || (canEdit && showEdit) || (canDelete && showDelete);
  if (withActions && hasAnyAction) {
    enhancedColumns.push({
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="d-flex align-items-center">
          {canView && showView && (
            <div className="me-1">
              <Button icon={<Icon icon="feather:eye" />} onClick={() => props.onView?.(record)} />
            </div>
          )}
          {canView && showImgView && (
            <div className="me-1">
              <Button icon={<Icon icon="feather:image" />} onClick={() => props.onImgView?.(record)} />
            </div>
          )}
          {showDownload && (
            <div className="me-1">
              <Button icon={<Icon icon="feather:download" />} onClick={() => props.onDownload?.(record)} />
            </div>
          )}
          {canEdit && showEdit && (
            <div className="me-1">
              <Button icon={<Icon icon="feather:edit" />} onClick={() => props.onEdit?.(record)} />
            </div>
          )}
          {canDelete && showDelete && (
            <div className="me-1">
              <Button icon={<Icon icon={record?.isActive ? "feather:trash-2" : "feather:rotate-ccw"} />} onClick={() => props.onDelete?.(record)} />
            </div>
          )}
        </div>
      )
    });
  }

  const totalRecords = props.pagination?.total || props.dataSource.length; // always 27 for display
  const pageSize = props.pagination?.pageSize || pagination.pageSize + 1; // per page kitne records show hnge
  const current = props.pagination?.current || pagination.current;  // konsa page number h 
  const currentLength = props.pagination?.currentLength   // api ne kitna data return kiya uskii lenthg
  // const totalPages = Math.ceil(totalRecords / pageSize);

  const handleChange = (newPage, newSize) => {
    setPagination({ current: newPage, pageSize: newSize });
    props.onChange?.({ current: newPage, pageSize: newSize });
  };
  return (
    <div className="table-responsive">
      {/* <input type="text" className="form-control d-none" title="Search Anything" placeholder="Krle Ab Search" onChange={(e)=> setSearch(e.target.value)} on/> */}
      <Table
        columns={enhancedColumns}
        dataSource={props.dataSource ?? []}
        pagination={false}
        onChange={props.onChange}
        rowSelection={rowSelection}
        loading={loading}
        bordered={bordered}
        size={size}
        scroll={{ x: "max-content" }}
        locale={{ emptyText }}
        footer={footer}
        rowKey={rowKey}
      />
      {!loading && props.pagination && (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 12 }}>
          <span>
            {props.dataSource.length === 0
              ? `0 of ${totalRecords} records`
              : `${(current - 1) * pageSize + 1}-${(current - 1) * pageSize + (props.currentLength || props.dataSource.length)} of ${totalRecords} records`}
          </span>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Button size="small" type="default" disabled={current === 1} onClick={() => handleChange(current - 1, pageSize)}>
              <Icon icon="feather:chevron-left" /> Previous
            </Button>
            <Button size="small" type="default"> {current} </Button>
            <Button size="small" type="default" disabled={currentLength < pageSize} onClick={() => handleChange(current + 1, pageSize)}>
              Next <Icon icon="feather:chevron-right" />
            </Button>
            <select className="d-none" value={pageSize} onChange={(e) => handleChange(1, Number(e.target.value))}>
              {[10, 15, 20, 50, 100].map((size) => (
                <option key={size} value={size}>
                  {size} / page
                </option>
              ))}
            </select>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomTable;